/**
 * 웹용 스텁: react-native-video 는 네이티브 전용 모듈.
 * VideoGoodsCard.tsx 의 `const RNVideo = !isWeb ? require(...) : null` 경로는
 * 웹에선 false 가드라 실제로 호출되지 않지만, Vite 가 빌드 타임에 해당 모듈을
 * 번들링하려 하다가 default export 부재로 실패하므로 빈 ES 모듈로 alias 처리.
 *
 * 실제 코드 경로에서 이 스텁의 멤버가 호출되면 안 됨 (호출 시 에러로 감지).
 */

const stub: Record<string, unknown> = {};

export default stub;

export const VideoView = () => null;

export const useVideoPlayer = () => {
  throw new Error(
    '[react-native-video stub] useVideoPlayer called on web. VideoPlayer should be guarded by !isWeb.',
  );
};
